import { metadataFilterKey } from './statisticalGraph';

export const GRAPH_ATTRIBUTE_FILTER_KEYS = ['timepoint', 'study', 'cohort', 'method', 'analysis', 'design'];
const shareKeys = ['view', 'context_types', 'types', ...GRAPH_ATTRIBUTE_FILTER_KEYS, 'isolated', 'references', 'focus', 'node', 'edge'];

export function readGraphShareState(search = '') {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const types = params.get('types');
  const contextTypes = params.get('context_types');
  let edge = null;
  try {
    const parsed = JSON.parse(params.get('edge') || 'null');
    if (Array.isArray(parsed) && parsed.length === 2 && parsed.every(value => typeof value === 'string')) edge = parsed;
  } catch { /* Ignore malformed shared edge state. */ }
  return {
    graphMode: ['statistics', 'context'].includes(params.get('view')) ? params.get('view') : 'network',
    contextSubtypes: contextTypes === null ? null : contextTypes.split('|').filter(Boolean),
    selectedCategories: types === null ? null : types.split('|').filter(Boolean),
    hideIsolatedNodes: params.get('isolated') !== '0',
    hideReferenceNodes: params.get('references') !== '0',
    attributeFilters: Object.fromEntries(GRAPH_ATTRIBUTE_FILTER_KEYS.map(key => {
      const value = params.get(key);
      return [key, value && key === 'design' ? metadataFilterKey(value, 'study_design') : value || null];
    })),
    focusNodeId: params.get('focus') || null,
    nodeId: params.get('node') || null,
    edge,
  };
}

export function writeGraphShareState(search = '', state = {}) {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  shareKeys.forEach(key => params.delete(key));
  if (['statistics', 'context'].includes(state.graphMode)) params.set('view', state.graphMode);
  if (Array.isArray(state.contextSubtypes)) params.set('context_types', state.contextSubtypes.join('|'));
  if (Array.isArray(state.selectedCategories)) params.set('types', state.selectedCategories.join('|'));
  for (const key of GRAPH_ATTRIBUTE_FILTER_KEYS) {
    if (state.attributeFilters?.[key]) params.set(key, state.attributeFilters[key]);
  }
  if (state.hideIsolatedNodes === false) params.set('isolated', '0');
  if (state.hideReferenceNodes === false) params.set('references', '0');
  if (state.focusNodeId) params.set('focus', state.focusNodeId);
  if (state.nodeId) params.set('node', state.nodeId);
  if (Array.isArray(state.edge) && state.edge.length === 2) params.set('edge', JSON.stringify(state.edge));
  return params.toString();
}

export function edgeEndpoints(link) {
  const endpoint = value => typeof value === 'object' && value !== null ? value.id : value;
  const source = endpoint(link?.source);
  const target = endpoint(link?.target);
  return source == null || target == null ? null : [String(source), String(target)].sort();
}

export function shareSelectionKey(selection = {}) {
  if (selection.edge) return JSON.stringify({ focusNodeId: selection.focusNodeId || null, edge: selection.edge });
  if (selection.nodeId) return JSON.stringify({ focusNodeId: selection.focusNodeId || selection.nodeId, nodeId: selection.nodeId });
  if (selection.focusNodeId) return JSON.stringify({ focusNodeId: selection.focusNodeId });
  return '';
}
